import { createAction } from 'redux-actions'

export const createSingleAction = type => createAction(type)
